import { createSlice } from "@reduxjs/toolkit";

export const addSeatSlice = createSlice({
  name: "addSeatSlice",
  initialState: {
    branch:null,
    selectedFloorDetails:null,
    floors:[],
    activeSelection:null,
    branchListFromApi:[],
    selectedElementDetails:null,
    seatSelection:false
  },

  reducers: {
    setBranch: (state, action) => {
      state.branch = action.payload;
    },
    setSelectedFloorDetails: (state, action) => {
      state.selectedFloorDetails = action.payload;
    },
    setFloors: (state, action) => {
      state.floors = action.payload;
    },
    setBranchList: (state, action) => {
      state.branchListFromApi = action.payload;
    },
    setSelectedElementDetails: (state, action) => {
      state.selectedElementDetails = action.payload;
    },
    setSeatSelection: (state, action) => {
      state.seatSelection = action.payload;
    },
    // Update a single element in floorCanvas (for instant texture/rotation updates)
    updateFloorCanvasElement: (state, action) => {
      const { elementId, updates } = action.payload;
      if (state.selectedFloorDetails?.floorCanvas) {
        state.selectedFloorDetails.floorCanvas = state.selectedFloorDetails.floorCanvas.map(
          (item) => item._id === elementId ? { ...item, ...updates } : item
        );
      }
      // Also update selectedElementDetails if it's the same element
      if (state.selectedElementDetails?._id === elementId) {
        state.selectedElementDetails = { ...state.selectedElementDetails, ...updates };
      }
    },
  },
});

export const {setSeatSelection,setSelectedElementDetails,setBranchList, setBranch,setSelectedFloorDetails,setFloors,updateFloorCanvasElement} = addSeatSlice.actions;

export default addSeatSlice.reducer;
